export const pagedDropdownI18NDe = {
    items: (first, last, total) => `${first}–${last} von ${total}`,
    page: (current, total) => `Seite ${current} / ${total}`,
};
